import ObjectShare from './container/index';

export default ObjectShare;



// WEBPACK FOOTER //
// ./src/views/ObjectShare/index.js